import { Link, useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();

  const handleAboutClick = (e) => {
    e.preventDefault();
    navigate("/");
    setTimeout(() => {
      const aboutSection = document.getElementById("about");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  // Replaced text-gray-300 with text-white
  const linkStyle = "inline-block text-white hover:text-[#B8860B] hover:translate-x-1 transition-transform duration-300 py-0.5 text-sm";

  return (
    <footer className="bg-[#2D4A3E] text-white py-8 md:py-10 px-6 md:px-12 border-t border-[#1f332b] min-h-[380px]">
      
      {/* Outer Grid: 1 column on mobile, 4 columns on desktop */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-8">

        {/* 1. BRAND (Takes 1 column on desktop) */}
        <div className="flex flex-col gap-2 lg:col-span-1">
          <h2 className="text-xl font-bold tracking-wide">
            S&S Law Offices
          </h2>
          <p className="text-xs text-white leading-relaxed opacity-90">
            Strategic Legal Solutions for Modern Businesses. Full-service legal and corporate consultancy since 2019.
          </p>
          <div className="flex gap-3 mt-1">
            <a 
              href="tel:+919045597604" 
              className="flex items-center justify-center w-8 h-8 bg-[#3f5f52] rounded-full hover:bg-[#B8860B] hover:scale-105 transition-all duration-300 shadow-sm text-white"
              aria-label="Call Us"
            >
              {/* Phone SVG */}
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </a>
            <a 
              href="mailto:sslegal1302@gmail.com" 
              className="flex items-center justify-center w-8 h-8 bg-[#3f5f52] rounded-full hover:bg-[#B8860B] hover:scale-105 transition-all duration-300 shadow-sm text-white"
              aria-label="Email Us"
            >
              {/* Email SVG */}
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </a>
          </div>
        </div>

        {/* 2 & 3. SERVICES & QUICK LINKS WRAPPER (Takes 2 columns on desktop, 2 columns on mobile) */}
        <div className="grid grid-cols-2 gap-4 lg:col-span-2">
          
          {/* SERVICES - Individual service pages */}
          <div>
            <h3 className="text-sm font-semibold mb-2 text-[#B8860B] uppercase tracking-wider">
              Services
            </h3>
            <ul className="space-y-1">
              <li><Link to="/services/ipr" className={linkStyle}>IPR Services</Link></li>
              <li><Link to="/services/startup" className={linkStyle}>Startup & MSME</Link></li>
              <li><Link to="/services/corporate" className={linkStyle}>Corporate & NCLT</Link></li>
              <li><Link to="/services/litigation" className={linkStyle}>Litigation</Link></li>
            </ul>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="text-sm font-semibold mb-2 text-[#B8860B] uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-1">
              <li><button onClick={handleAboutClick} className={`text-left ${linkStyle}`}>About Us</button></li>
              <li><Link to="/team" className={linkStyle}>Our Team</Link></li>
              <li><Link to="/tools" className={linkStyle}>Tools & Calculators</Link></li>
              <li><Link to="/blog" className={linkStyle}>Blog / Insights</Link></li>
              <li><Link to="/contact" className={linkStyle}>Contact</Link></li>
            </ul>
          </div>

        </div>

        {/* 4. CONTACT (Takes 1 column on desktop) */}
        <div className="lg:col-span-1">
          <h3 className="text-sm font-semibold mb-2 text-[#B8860B] uppercase tracking-wider">
            Contact
          </h3>
          <ul className="space-y-2 text-sm text-white">
            <li className="flex items-start gap-2.5">
              {/* Map Pin SVG */}
              <span className="mt-0.5 text-[#B8860B] shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
                </svg>
              </span>
              <span className="leading-snug text-xs">
                Advocate Chamber 5, Top Floor, RDC, Ghaziabad, UP – 201001
              </span>
            </li>
            <li>
              <a href="mailto:sslegal1302@gmail.com" className="flex items-center gap-2.5 hover:text-[#B8860B] transition-colors duration-300 text-xs">
                {/* Email SVG */}
                <span className="text-[#B8860B] shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </span>
                <span className="break-all">sslegal1302@gmail.com</span> 
              </a>
            </li>
            <li>
              <a href="tel:+919045597604" className="flex items-center gap-2.5 hover:text-[#B8860B] transition-colors duration-300 text-xs">
                {/* Phone SVG */}
                <span className="text-[#B8860B] shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </span>
                <span>+91 90455 97604</span>
              </a>
            </li>
          </ul>
        </div>

      </div>

      {/* BOTTOM BAR: DISCLAIMER & COPYRIGHT */}
      <div className="max-w-7xl mx-auto border-t border-[#3f5f52] mt-8 pt-4 text-[11px] text-white/90">
        <p className="mb-2 leading-relaxed text-justify md:text-center max-w-5xl mx-auto">
          <strong className="text-white">Disclaimer:</strong> This website is created solely for informational purposes in compliance with Bar Council of India rules. It does not constitute solicitation or advertisement. The content is not legal advice. Users are advised to seek independent legal counsel.
        </p>
        <p className="text-center text-white font-medium">
          © {new Date().getFullYear()} S&S Law Offices. All rights reserved. 
          <span className="block sm:inline sm:ml-2 opacity-80">
            Established 2019 • Delhi NCR, India
          </span>
        </p>
      </div>

    </footer>
  );
}

export default Footer;